// TODO: bad naming of the file/component
import React, { useState, ReactElement, useEffect } from 'react';
import axiosConfig from '../../utils/axiosConfig';
import { useParams } from 'react-router-dom';
import { Notification } from '../../interfaces/backend/Notifications';
import { Environments } from '../../api/environments/interface';
import { Auth } from 'aws-amplify';
import { User } from '../../interfaces/api/Auth';
import NotificationTabs from './NotificationTabs';
import { setAWSCreds } from '../../utils/accessToken';
import { getNotification, putNotification } from '../../api/notifications';
import Loading from '../loading';
import { AccountSummary } from '../../App';
import { Channels } from '../common/channelsEnum';

export enum EmailDeliveryOptionsEnum {
  OFF = 'off',
  INSTANT = 'instant',
  HOURLY = 'hourly',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly'
}

export enum InappWebDeliveryOptionsEnum {
  OFF = 'off',
  INSTANT = 'instant'
}

export const DEFAULT_NOTIFICATION_OPTIONS: Notification['options'] = {
  [Channels.EMAIL]: {
    defaultDeliveryOption: EmailDeliveryOptionsEnum.INSTANT,
    off: {
      enabled: true
    },
    instant: {
      enabled: true
    },
    hourly: {
      enabled: false
    },
    daily: {
      enabled: false,
      hour: '08:00'
    },
    weekly: {
      enabled: false,
      hour: '09:00',
      day: 'Monday'
    },
    monthly: {
      enabled: false,
      hour: '10:00',
      date: 'first'
    }
  },
  [Channels.INAPP_WEB]: {
    defaultDeliveryOption: EmailDeliveryOptionsEnum.INSTANT,
    off: {
      enabled: true
    },
    instant: {
      enabled: true
    }
  }
};

const NotificationTabsContainer = (props: {
  accountSummary: AccountSummary;
}): ReactElement => {
  const { notificationId } = useParams<{ notificationId: string }>();
  const { accountId } = useParams<{ accountId: string }>();
  const { tabId } = useParams<{ tabId: string }>();
  const [notification, setNotification] = useState<Notification>();
  const [environment, setEnvironment] = useState<Environments>();
  const [user, setUser] = useState<User>();

  useEffect(() => {
    setAWSCreds().then(async () => {
      const res = await getNotification(accountId, notificationId);
      if (!res) return;
      const item = {
        ...res,
        options: { ...DEFAULT_NOTIFICATION_OPTIONS, ...res.options }
      };
      setNotification(item);
    });
  }, [accountId, notificationId]);

  useEffect(() => {
    Auth.currentUserPoolUser().then((user: User) => {
      setUser(user);
    });
  }, []);

  useEffect(() => {
    axiosConfig('get', `environments`, {}, (response) => {
      const res = response as Record<'data', Environments[]>;
      setEnvironment(res.data[0]);
    });
  }, []);

  const updateNotification = async (notification: Notification) => {
    await putNotification(notification);
    setNotification(notification);
  };

  if (!notification || !environment || !user) return <Loading />;

  return (
    <NotificationTabs
      tabId={tabId}
      environment={environment}
      notification={notification}
      updateNotification={updateNotification}
      user={user}
      accountSummary={props.accountSummary}
    />
  );
};
export default NotificationTabsContainer;
